import { AloftDate, AloftTime, isDefined } from '@aloft/toolkit-shared';

import { TkOrderListfield, TkOrderListing } from '../types.ts';
import { getTkv2SortAccessor } from './getTkv2SortAccessor.ts';

export const sortTkOrderListings = (
  orders: TkOrderListing[],
  { field, dir }: { field: TkOrderListfield; dir: 'asc' | 'desc' },
) =>
  [...orders].sort((a, b) => {
    // Always put legacy orders at the bottom
    if (a.type === 'legacy' && b.type === 'tkv2') {
      return 1;
    } else if (b.type === 'legacy' && a.type === 'tkv2') {
      return -1;
    }

    const aVal = getTkv2SortAccessor(field)(a);
    const bVal = getTkv2SortAccessor(field)(b);

    if (dir === 'asc') {
      if (isDefined(aVal) && isDefined(bVal)) {
        if (AloftDate.isAloftDate(aVal) && AloftDate.isAloftDate(bVal)) {
          return aVal.compare(bVal);
        } else if (AloftTime.isAloftTime(aVal) && AloftTime.isAloftTime(bVal)) {
          return aVal.compare(bVal);
        }
        return aVal < bVal ? -1 : 1;
      } else if (isDefined(aVal)) {
        return -1;
      } else if (isDefined(bVal)) {
        return 1;
      } else {
        return 0;
      }
    } else {
      if (isDefined(aVal) && isDefined(bVal)) {
        if (AloftDate.isAloftDate(aVal) && AloftDate.isAloftDate(bVal)) {
          return bVal.compare(aVal);
        } else if (AloftTime.isAloftTime(aVal) && AloftTime.isAloftTime(bVal)) {
          return bVal.compare(aVal);
        }
        return aVal > bVal ? -1 : 1;
      } else if (isDefined(aVal)) {
        return 1;
      } else if (isDefined(bVal)) {
        return -1;
      } else {
        return 0;
      }
    }
  });
